import {
  FaChevronDownRegular,
  FaChevronRightRegular,
  FaTriangleExclamationSolid,
  FaXmarkRegular,
} from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

// AdminApprovalFlow 専用の DS icon wrapper。新規実装は @enechain/ecloud-icons を直接使う。

export const WarningTriangleIcon = ({
  color,
  /**
   * design は置き場所ごとに大きさを変える (バッジ内 12px = `approval-flow.html:1052` /
   * 保存ヒント・未設定表示 14px = 同 :1592・:1990)。 既定は従来どおり 16px。
   */
  boxSize = iconSize.gridInline,
}: {
  color?: string
  boxSize?: string
}): React.ReactElement => (
  <FaTriangleExclamationSolid
    boxSize={boxSize}
    color={color}
    aria-hidden="true"
  />
)

/**
 * accordion の開閉アイコン。 design (`css/components.css:4051-4064`) は 12px /
 * `--object-mid-emphasis` で、 **閉じ = chevron-right / 開き = chevron-down の
 * グリフ差し替え** (同 :4054-4058 に「回転させるのではない」と明記)。
 */
export const ChevronDownIcon = (): React.ReactElement => (
  <FaChevronDownRegular
    boxSize={iconSize.badgeIcon}
    color="Object.midEmphasis"
    aria-hidden="true"
  />
)

export const CloseIcon = (): React.ReactElement => (
  <FaXmarkRegular aria-hidden="true" />
)

/** accordion の閉じ状態アイコン (design 12px / --object-mid-emphasis)。 */
export const ChevronRightIcon = (): React.ReactElement => (
  <FaChevronRightRegular
    boxSize={iconSize.badgeIcon}
    color="Object.midEmphasis"
    aria-hidden="true"
  />
)
